// components/NotFound.js
import React from 'react';
import {Link } from 'react-router-dom'
import SeoHelmet from './SeoHelmet';
const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <SeoHelmet title="Page Not Found" robots="noindex, nofollow" path="/404" />
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Link to='/'>Back To Home</Link>
    </div>
  );
};

export default NotFound;
